import { useTranslation } from "react-i18next";

const SMSButton = () => {
  const { t } = useTranslation();
  const phoneNumber = "+12064744668";
  const message = encodeURIComponent("Hi Prime Shine WA! I'd like to get a free quote for cleaning services.");

  return (
    <a
      href={`sms:${phoneNumber}?body=${message}`}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 bg-[#0F2A44] text-white px-4 py-3 rounded-full cursor-pointer group transition-all duration-300 hover:scale-105 hover:bg-[#1a4a7a]"
      style={{ boxShadow: "0 4px 20px rgba(15,42,68,0.4)" }}
      aria-label="Send us a text message"
    >
      <div className="w-6 h-6 flex items-center justify-center">
        <i className="ri-message-2-fill text-xl text-[#D4AF37]" />
      </div>
      <span className="text-sm font-semibold whitespace-nowrap hidden sm:inline">
        {t("contact_sms") || "Text Us Now"}
      </span>
    </a>
  );
};

export default SMSButton;
